import router from '@/router'
import jwtToken from '@/plugins/jwt/jwt-token.js'
import axios from 'axios'
import toast from '@/plugins/toast'

if (process.env.NODE_ENV === 'production') {
  axios.defaults.baseURL = "https://api.reclamaciondesiniestros.com";
} else {
  axios.defaults.baseURL = "http://localhost:8000";
}

axios.interceptors.request.use(config => {
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  if (jwtToken.getToken()) {
    config.headers['Authorization'] = `Bearer ${jwtToken.getToken()}`;
  }
  return config;
}, error => {
  return Promise.reject(error);
});

axios.interceptors.response.use(response => {
  
  if(
    response.data.status == "Token has Expired" || 
    response.data.status == "Token not provided"  || 
    response.data.status == "Token is Invalid" || 
    response.data.status == "Authorization Token not found"
  ) {
    jwtToken.removeToken();
    router.push({path: '/login'});
  }

  return response;
}, error => {
  
  console.log(error)

  if(error['response'] == undefined){
      toast.openToast("Error de conexión, intente nuevamente","error",2000)
      return Promise.reject(error);
  }

  const status = error['response']['status'];
  const backendError = error['response']['data'] && error['response']['data']['error'];

  if(status == 401){
    toast.openToast("Autenticación fallida","error",2000)
    jwtToken.removeToken();
    router.push({path: '/login'});
  }else if(status == 422 && backendError && backendError.message){
    let html = "";
    for(let m in backendError.message){
      html +=  backendError.message[m]+'<br>'
    }
    toast.openToast(html,"error",2000)
  }else if(backendError && backendError.message){
    // Cualquier otro error con mensaje explicativo del back (500, 503 de un
    // servicio externo caído, etc.) — se muestra tal cual, sin filtrar
    // detalles internos (línea/fichero) a usuarias que no son técnicas.
    toast.openToast(backendError.message,"error",2000)
  }else{
    toast.openToast("Error de conexión, intente nuevamente","error",2000)
  }

  return Promise.reject(error);
});


export default axios
